import * as yup from 'yup';

const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
const PASSWORD_REQUIREMENTS_MESSAGE =
  'Password must be at least 8 characters and include at least 1 letter, 1 number, and 1 special character (@, $, !, %, *, #, ?, &). Only letters, numbers, and these special characters are allowed.';

const registrationValidationSchema = yup.object().shape({
  name: yup.string().required('Required'),
  phoneCode: yup.string().required('Required'),
  phoneNumber: yup.string().required('Required'),
  email: yup.string().email('Invalid email address').required('Required'),
  password: yup
    .string()
    .required('Required')
    .matches(
      PASSWORD_REGEX,
      PASSWORD_REQUIREMENTS_MESSAGE
    ),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
    .required('Required'),
});

export default registrationValidationSchema;
